module.exports = __webpack_public_path__ + "img/img5_7.8bb6df4c.jpeg";